const LOGIN_REDIRECT_URI =
  process.env.LOGIN_REDIRECT_URI || "http://localhost:3000/";
const LOGOUT_REDIRECT_URI =
  process.env.LOGOUT_REDIRECT_URI || "http://localhost:3000/";
const KEYCLOAK_URL =
  process.env.KEYCLOAK_URL || "https://qa-access-key-corp.falabella.tech/auth";
const CLIENT_ID = process.env.CLIENT_ID || "portal";
const REALM = process.env.REALM || "corp";
const APP_NAME = process.env.APP_NAME || "authentication";
const APP_DEV: boolean = process.env.APP_DEV === "true";
const STORE_DEBUG = process.env.STORE_DEBUG === "true";
const KEYCLOAK_DEBUG = process.env.KEYCLOAK_DEBUG === "true";
const SILENT_CHECK_SSO_FILE =
  process.env.SILENT_CHECK_SSO_FILE || "silent-check-sso.html";
const LOCAL_STORAGE_SUFFIX = process.env.LOCAL_STORAGE_SUFFIX || "fpkt";

export {
  LOGIN_REDIRECT_URI,
  LOGOUT_REDIRECT_URI,
  KEYCLOAK_URL,
  CLIENT_ID,
  REALM,
  APP_NAME,
  STORE_DEBUG,
  KEYCLOAK_DEBUG,
  APP_DEV,
  SILENT_CHECK_SSO_FILE,
  LOCAL_STORAGE_SUFFIX,
};
